import React from "react";
import useAuthContext from "./Auth";
import { PageLayout } from "../ui";
import ShopperCart from "../pages/ShopperCart";

const withoutRouter = (page) => (
  <PageLayout.Container key="container">{page}</PageLayout.Container>
);

const Router = () => {
  const { shopperCartCode } = useAuthContext();

  if (shopperCartCode) {
    return withoutRouter(<ShopperCart key="shopper_cart" />);
  }
  return null;
};

export default Router;
